import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { SessionTimeoutService } from '../../services/session-timeout.service';

@Component({
  selector: 'app-session-timeout-warning',
  templateUrl: './session-timeout-warning.component.html',
  styleUrls: ['./session-timeout-warning.component.css']
})
export class SessionTimeoutWarningComponent implements OnInit, OnDestroy {
  remainingMinutes: number = 0;
  remainingSeconds: number = 30; // Default to 30 seconds minimum
  private countdownInterval: any;
  private warningSubscription: Subscription;
  private initialTimeSet: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private sessionTimeoutService: SessionTimeoutService
  ) {}

  ngOnInit(): void {
    // Subscribe to warning updates
    this.warningSubscription = this.sessionTimeoutService.warning$.subscribe(
      (time) => {
        // Update the countdown time
        this.remainingMinutes = time.minutes;
        this.remainingSeconds = time.seconds;
        
        // Restart countdown with new time
        if (this.countdownInterval) {
          clearInterval(this.countdownInterval);
        }
        this.startCountdown();
        
        if (!this.initialTimeSet) {
          this.initialTimeSet = true;
        }
      }
    );

    // Try to get the latest warning value immediately if available
    // Note: This is a workaround since Subject doesn't have a getValue() method
    // The subscription above will handle updates
    
    // If no initial value received within 500ms, start with default
    setTimeout(() => {
      if (!this.initialTimeSet) {
        this.remainingMinutes = 0;
        this.remainingSeconds = 30;
        this.initialTimeSet = true;
        this.startCountdown();
      }
    }, 500);
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    if (this.warningSubscription) {
      this.warningSubscription.unsubscribe();
    }
  }

  /**
   * Start countdown timer
   */
  private startCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    // Ensure we have valid values
    if (this.remainingMinutes < 0) this.remainingMinutes = 0;
    if (this.remainingSeconds < 0) this.remainingSeconds = 0;
    if (this.remainingMinutes === 0 && this.remainingSeconds === 0) {
      this.remainingSeconds = 30; // Give at least 30 seconds
    }

    this.countdownInterval = setInterval(() => {
      if (this.remainingSeconds > 0) {
        this.remainingSeconds--;
      } else if (this.remainingMinutes > 0) {
        this.remainingMinutes--;
        this.remainingSeconds = 59;
      } else {
        // When countdown reaches zero, trigger logout
        clearInterval(this.countdownInterval);
        // Close modal and trigger logout
        this.activeModal.dismiss('expired');
        // Trigger session expired to ensure logout happens
        this.sessionTimeoutService.forceSessionExpired();
      }
    }, 1000);
  }

  /**
   * Format time to two digits
   */
  formatTime(value: number): string {
    return value.toString().padStart(2, '0');
  }

  /**
   * Extend session by updating activity
   */
  extendSession(): void {
    this.sessionTimeoutService.extendSession().subscribe(
      () => {
        this.activeModal.close('extended');
        // Reload page to refresh session
        window.location.reload();
      },
      (error) => {
        console.error('Error extending session:', error);
        // Even on error, close modal and reload
        this.activeModal.close('extended');
        window.location.reload();
      }
    );
  }

  /**
   * Close modal without extending
   */
  dismiss(): void {
    this.activeModal.dismiss('dismissed');
  }
}

